<div class="course-progress-bar">
  <div class="progress-container flex items-center gap-2 sm:gap-3">
    <button
      type="button"
      class="nav-btn"
      [disabled]="currentStep <= 1"
      (click)="movePrevious()">
      <i class="fa-solid fa-angle-left"></i>
    </button>

    <div class="steps-wrapper flex min-w-0 flex-1 items-center gap-2 overflow-x-auto py-1">
      @for (stepLabel of stepLabels; track stepLabel; let index = $index; let last = $last) {
        <div class="progress-step flex items-center gap-1" [class.active]="currentStep >= index + 1">
          <div class="step-number" [class.active]="currentStep >= index + 1">{{ index + 1 }}</div>
          <div class="step-label whitespace-nowrap" [class.step-active]="currentStep >= index + 1">{{ stepLabel | translate }}</div>
        </div>
        @if (!last) {
          <div class="progress-line flex-1" [class.completed]="currentStep > index + 1"></div>
        }
      }
    </div>

    <button
      type="button"
      class="nav-btn"
      [disabled]="currentStep >= totalSteps"
      (click)="moveNext()">
      <i class="fa-solid fa-angle-right"></i>
    </button>
  </div>
</div>
